import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 retreive_add_stock_details: { message: "idle" },
};

export const retreive_add_stock_details_Slice = createSlice({
 name: "retreive_add_stock_details",
 initialState,
 reducers: {
  success_retreive_add_stock_details: (state, action) => {
   state.retreive_add_stock_details = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_retreive_add_stock_details: (state, action) => {
   state.retreive_add_stock_details = { status: app_consts.FAIL, message: action.payload };
  },
  reset_retreive_add_stock_details: (state) => {
   state.retreive_add_stock_details = { status: app_consts.IDLE };
  },
  loading_retreive_add_stock_details: (state) => {
   state.retreive_add_stock_details = { status: app_consts.LOADING };
  },
 }
});

export const { success_retreive_add_stock_details, fail_retreive_add_stock_details, reset_retreive_add_stock_details, loading_retreive_add_stock_details } = retreive_add_stock_details_Slice.actions;

export default retreive_add_stock_details_Slice.reducer;